import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CookieConsentBanner from "@/components/CookieConsentBanner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import ForIndividuals from "@/pages/ForIndividuals";
import ForBusinesses from "@/pages/ForBusinesses";
import ServiceDetail from "@/pages/ServiceDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import CryptoTaxCalculator from "@/pages/calculators/CryptoTaxCalculator";
import TDSCalculator from "@/pages/calculators/TDSCalculator";
import ProfitLossCalculator from "@/pages/calculators/ProfitLossCalculator";
import StakingCalculator from "@/pages/calculators/StakingCalculator";
import SIPCalculator from "@/pages/calculators/SIPCalculator";
import Tools from "@/pages/Tools";
import NotFound from "@/pages/NotFound";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col bg-[#F5F5F2]">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/individuals" element={<ForIndividuals />} />
            <Route path="/businesses" element={<ForBusinesses />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/category/:categorySlug" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsConditions />} />
            <Route path="/tools" element={<Tools />} />
            <Route path="/calculators/crypto-tax-calculator-india" element={<CryptoTaxCalculator />} />
            <Route path="/calculators/crypto-tds-calculator" element={<TDSCalculator />} />
            <Route path="/calculators/crypto-profit-loss-calculator" element={<ProfitLossCalculator />} />
            <Route path="/calculators/crypto-staking-rewards-calculator" element={<StakingCalculator />} />
            <Route path="/calculators/crypto-sip-calculator" element={<SIPCalculator />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsentBanner />
      </div>
    </BrowserRouter>
  );
}

export default App;
